import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router';
import { ResponsiveValue, Theme } from 'styled-system';

import { Box, styled, themeGet, BoxProps, FontSize } from '@qwealth/qcore';

export const NavigationLinkStyled = styled(Box)<{
  $hasLink?: boolean;
  $isDisabled?: boolean;
  $fontSize?: ResponsiveValue<keyof typeof FontSize, Theme>;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${props => (props.$isDisabled ? themeGet('colors.gray.1') : themeGet('default'))};
  font-weight: ${themeGet('fontWeights.bold')};
  gap: ${themeGet('space.small')};
  width: fit-content;
  cursor: ${props => (props.$hasLink && !props.$isDisabled ? 'pointer' : 'default')};
  font-size: ${props => themeGet('fontSizes.' + props.$fontSize || 'default')};

  &:hover {
    color: ${props => (props.$hasLink && !props.$isDisabled ? themeGet('colors.primaryLight.1') : themeGet('default'))};
  }
`;

interface NavigationLinkProps {
  content: {
    label: string | undefined;
    link?: string;
  };
  icon?: JSX.Element;
  isDisabled?: boolean;
}

type CombinedProps = NavigationLinkProps & BoxProps;

const NavigationLink: React.FC<CombinedProps> = ({ content, icon, isDisabled, fontSize }): ReactElement => {
  const navigate = useNavigate();
  const handleNavigationLinkClick = () => {
    if (content.link && !isDisabled) {
      navigate(content.link);
    }
  };

  return (
    <NavigationLinkStyled
      onClick={handleNavigationLinkClick}
      $hasLink={content.link ? true : false}
      $isDisabled={isDisabled}
      $fontSize={fontSize || 'default'}
    >
      {icon && (
        <Box display="flex" alignItems="center">
          {icon}
        </Box>
      )}
      {content.label ? content.label : 'N/A'}
    </NavigationLinkStyled>
  );
};

export default NavigationLink;
